const MuiTypography = {
  defaultProps: {
    variantMapping: {
      body1: 'span',
      body2: 'span',
    },
  },
  styleOverrides: {
    root: {
      letterSpacing: '1px',
    },
  },
};

export default MuiTypography;
